import styled, { css } from 'styled-components';

export const Toggle = styled.div<{ $size: string; $active: boolean }>(
  ({ theme, $active, $size }) => css`
    width: ${$size === 'big' ? '79px' : '52px'};
    height: 30px;
    border-radius: 3px;
    background-color: ${$active ? theme.lightBlue.a10 : '#eeeeee'};
    align-self: center;
    left: ${$active ? ($size === 'big' ? '83px' : '56px') : '3px'};
    top: 3px;
    font-size: 0.9rem;
    line-height: 2.17;
    letter-spacing: 0.2px;
    text-align: center;
    color: ${$active ? theme.white.a10 : theme.black.a3};
    transition: all 0.36s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    position: absolute;
  `,
);
Toggle.displayName = 'Toggle';

export const ToggleBoxContainer = styled.div<{ $size: string }>`
  padding: 3px;
  display: flex;
  width: ${({ $size }) => ($size === 'big' ? '168px' : '115px')};
  height: 38px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.white.a10};
  border: solid 1px ${({ theme }) => theme.black.a1};
  cursor: pointer;
  position: relative;
`;
ToggleBoxContainer.displayName = 'ToggleBoxContainer';

export const EmptyMessage = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  width: 50%;
  line-height: 2.17;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 1px;
`;
